"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ELigneMetier = void 0;
exports.ELigneMetier = {
    ASSURANCE: "assurance",
    CIF: "cif",
    BANQUE: "banque",
};
